import * as React from "react";
import { Icon, IconsList } from "../icons";
import * as rootStyles from "../../../styles";
import { Card, Row } from "react-bootstrap";

export type InlineErrorProps = {
    text: string;
    retryAction?: () => void;
    onDismiss?: () => void;
    sticky?: boolean;
    id: string;
};

export class InlineError extends React.Component<InlineErrorProps> {
    render() {
        let icon;
        let action;
        if (!this.props.sticky) {
            action = this.props.retryAction
                ? this.props.retryAction
                : this.props.onDismiss;
            icon = (
                <Icon
                    size={16}
                    icon={
                        this.props.retryAction
                            ? IconsList.navigation_refresh
                            : IconsList.action_cancelInline
                    }
                    id={`${this.props.id}_Retry`}
                />
            );
        }
        return (
            <Card style={headerErrorContainer} onClick={action}>
                <Row id={this.props.id + "-ErrorText"} style={innerErrorStyle}>
                    <span style={textStyle}>
                        {this.props.text}
                        {icon && <span style={iconStyle}>{icon}</span>}
                    </span>
                </Row>
            </Card>
        );
    }
}

const innerErrorStyle: React.CSSProperties = {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
};
const textStyle: React.CSSProperties = {
    alignSelf: "center",
    ...rootStyles.textStyles.primary,
};
const iconStyle: React.CSSProperties = {
    display: "inline-flex",
    verticalAlign: "middle",
    marginLeft: rootStyles.spacers.micro,
};
const headerErrorContainer: React.CSSProperties = {
    ...rootStyles.errorStyles.errorContainer,
    height: 75,
    maxHeight: 75,
};
